import React from 'react';
import { ODGNBLogoType } from '../../../interfaces/gnbInterfaces';
import { ODGNBTextLogo } from './variants/ODGNBTextLogo';
export var ODGNBLogo = function (props) {
    var type = props.def.type;
    switch (type) {
        case ODGNBLogoType.Text:
            return React.createElement(ODGNBTextLogo, { def: props.def });
    }
};
//# sourceMappingURL=ODGNBLogo.js.map